import { render, staticRenderFns } from "./budgetForecastClient.vue?vue&type=template&id=6811903a&scoped=true"
import script from "./budgetForecastClient.vue?vue&type=script&lang=js"
export * from "./budgetForecastClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811903a",
  null
  
)

export default component.exports